import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType, ChartTimerName, ChartTimerStatus } from '@frontend/chart/types';

import { TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT } from '../transaction-chart-endpoints';

export const TRANSACTION_TIMER_DROP_OFF_PENDING_COMPLETED_VOLUME_BAR_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.TRANSACTION_TIMER_DROP_OFF_PENDING_COMPLETED_VOLUME_BAR,
    chartType: ChartRendererType.BAR,
    endpoint: TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.NAME, value: ChartTimerName.TRANSACTION_DROP_OFF_PENDING },
        { key: ChartQueryParam.STATUS, value: ChartTimerStatus.COMPLETED },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.MONTH }
    ]
};
